import { useEffect, useRef, useState } from "preact/hooks";
import register from "preact-custom-element";
import { BackgroundRegistry } from "./BackgroundRegistry";

const backgroundRegistry = new BackgroundRegistry();

const BetterBackground = ({ }) => {
  const slotRef = useRef<HTMLSlotElement>(null);
  const [mixedColor, setMixedColor] = useState<string>("inherit");

  useEffect(() => {
    const root = slotRef.current?.getRootNode();
    const host = root instanceof ShadowRoot ? (root.host as HTMLElement) : undefined;
    return backgroundRegistry.addBackground(host, () => {
      setMixedColor(backgroundRegistry.getMixedColor());
    });
  }, []);

  return <><div style={{ backgroundColor: mixedColor, transition: "background-color 0.1s ease" }}>
    <slot ref={slotRef} />
  </div>
    <style type="text/css">{`
      :host {
        background-color: inherit;
      }
    `}</style>
  </>;
};

register(BetterBackground, "better-background", [], { shadow: true });
